import { StatePanel, type StatePanelProps } from './state-panel';

export const ErrorPanel = (props: Omit<StatePanelProps, 'tone'>) => (
  <StatePanel tone='error' {...props} />
);
